import { SET_PROJECT, SET_PROJECT_UNDOABLE } from './project';
import { fromJS, Map } from 'immutable';
import { takeLatest, put, select, call } from 'redux-saga/effects';
import { getPrice } from '../utils/apiServices';
import { projectMetadataSelector } from '../reducers/selectors';
import { SET_PRICING, setPricing } from './pricing';

const SET_CLIENT_RENDER_WIDTH = 'SET_CLIENT_RENDER_WIDTH';
const SET_COST = 'SET_COST';

export function setClientRenderWidth(clientRenderingWidth) {
  return {
    type: SET_CLIENT_RENDER_WIDTH,
    clientRenderingWidth,
  };
}

export function setCosts(pageCount, cost) {
  return {
    type: SET_COST,
    pageCount,
    cost,
  };
}

const reducer = (state = new Map(), action) => {
  switch (action.type) {
    case SET_PROJECT_UNDOABLE:
    case SET_PROJECT:
      return action.project.productInfo !== undefined
        ? fromJS(action.project.productInfo)
        : state;
    case SET_CLIENT_RENDER_WIDTH:
      return state.set('clientRenderingWidth', action.clientRenderingWidth);
    case SET_COST:
    case SET_PRICING:
      return state.setIn(
        ['pricing', action.pageCount],
        action.cost ?? action.pricing,
      );
    default:
      return state;
  }
};

function* setupSagas() {
  yield takeLatest([SET_PROJECT, SET_PROJECT_UNDOABLE], getPriceHandler);
}

function* getPriceHandler(action) {
  // Price change check only if the sections load - same sections same pages
  if (action.project && action.project.sections) {
    const projectMeta = yield select(projectMetadataSelector);
    try {
      const priceObject = yield call(
        getPrice,
        projectMeta.get('numPages'),
        projectMeta.getIn(['product', 'pk']),
      );
      if (priceObject) {
        yield put(setCosts(projectMeta.get('numPages'), priceObject));
        yield put(setPricing(projectMeta.get('numPages'), priceObject));
      }
    } catch (err) {
      console.error('getPriceHandler error', err);
    }
  }
}

export default {
  reducer: reducer,
  saga: setupSagas,
};
